export type HeadingLevel = 1 | 2 | 3 | 4 | 5 | 6

interface SectionTitleProps {
  level: HeadingLevel
  isSemantic: boolean
  invertedStyles?: ComputedRef<{ [key: string]: boolean }> | undefined
}

/**
 * Generates section heading level based on index.
 * - First section (index 0): H1
 * - All other sections: H2
 * - Falls back to div when wantsSemantic is false
 *
 * @param {number} moduleIndex - The index of the section module (0-based)
 * @param {boolean} [hasHeading=true] - Whether this section has a heading
 * @param {boolean} [wantsSemantic=true] - Whether to render semantic heading tags
 * @returns {SectionTitleProps} Object containing level and isSemantic
 */
export default function useSectionRules(
  moduleIndex: number,
  invertColorTheme: boolean = false,
  hasHeading: boolean = true,
  wantsSemantic: boolean = true
): SectionTitleProps {
  const store = useAppStore()
  // Determine heading level: H1 for first section, H2 for all others
  const level: HeadingLevel = moduleIndex === 0 ? 1 : 2

  // Semantic only if section has heading and wants semantic tags
  const isSemantic = hasHeading && wantsSemantic

  // Update Menu Colors
  const isMenuInvertColors = useState('menuInvertColors')

  if (moduleIndex === 0) {
    isMenuInvertColors.value = invertColorTheme
  }

  return {
    level,
    isSemantic,
    invertedStyles: computed(() => {
      return invertColorTheme
        ? {
            'bg-black text-white': store.theme === AppTheme.LIGHT,
            'bg-white text-black': store.theme === AppTheme.DARK
          }
        : undefined
    })
  }
}
